/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 * See the LICENSE file for the full text.
 */

import React from 'react';
import OrgField from './OrgField';

/**
 * A `datetime-local` input.
 *
 * The value is a WALL CLOCK — `YYYY-MM-DDTHH:MM`, with no zone attached. It is
 * read against the event's own `timezone` on the way out (`buildEventBatch`)
 * and on the way back in (`hydrateEventForm`), never against the browser's. An
 * organizer in Delhi scheduling a London event types London time; that is the
 * whole point of the separate timezone field, and this control must not try to
 * be clever about it.
 */
export default function OrgDateTime({ label, value, onChange, required, error, help }) {
  return (
    <OrgField label={label} required={required} error={error} help={help}>
      {({ id, invalid, describedBy }) => (
        <input
          id={id}
          className="orgf-input"
          type="datetime-local"
          value={value ?? ''}
          aria-invalid={invalid}
          aria-describedby={describedBy}
          onChange={(event) => onChange(event.target.value)}
        />
      )}
    </OrgField>
  );
}
